<ng-order-history-header
  *ngIf="(store$ | async) as store"
  [loadingLocations]="store.state.loadingLocations"
  [loadingPatterns]="store.state.loadingPatterns"
  [loadingDateRange]="store.state.loadingDateRange"
  [locations]="store.state.locations"
  [patterns]="store.state.patterns"
  [classCode]="selectedClassCode"
  [selectedCustomer]="customer"
  [customDateRange]="customDateRange"
  [dateRange]="store.state.dateRange"
  [dateInterval]="store.state.dateInterval"
  (updateDateInterval)="updateDateInterval($event)"
  (selectedOrderFill)="selectedOrderFill.emit($event)"
  (selectPatterns)="selectPattern($event)"
  (selectedDateInterval)="selectedDateRange($event)"
></ng-order-history-header>
